import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Popover, Typography, } from '@mui/material';
import { days, weekends, workdays } from 'z3k-config';
import { FileCopy } from '@mui/icons-material';
import * as lodash from 'lodash';
const _workdays = workdays.map((d) => d.id);
const _weekends = weekends.map((d) => d.id);
export const DaysPopup = memo(function DaysPopup(props) {
    const { anchorEl, onClose, current_day, doCopy } = props;
    const [copy_2_days, setCopyToDays] = useState([current_day]);
    const onChangeDays = useCallback((day_id) => (e) => {
        if (e.target.checked) {
            setCopyToDays((days) => [...days, day_id]);
        }
        else {
            setCopyToDays((days) => days.filter((_day_id) => _day_id !== day_id));
        }
    }, [setCopyToDays]);
    const onChangeWeekDays = useCallback((e) => {
        if (e.target.checked) {
            setCopyToDays((days) => [...new Set([...days, ..._workdays])]);
        }
        else {
            setCopyToDays((days) => days.filter((_day_id) => !_workdays.includes(_day_id)));
        }
    }, [setCopyToDays]);
    const onChangeWeekends = useCallback((e) => {
        if (e.target.checked) {
            setCopyToDays((days) => [...new Set([...days, ..._weekends])]);
        }
        else {
            setCopyToDays((days) => days.filter((_day_id) => !_weekends.includes(_day_id)));
        }
    }, [setCopyToDays]);
    const onClickCopy = useCallback(() => {
        doCopy(copy_2_days);
        onClose();
    }, [doCopy, onClose, copy_2_days]);
    return (_jsxs(Popover, { open: !!anchorEl, onClose: onClose, anchorEl: anchorEl, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, disableRestoreFocus: true, children: [_jsx(Box, { m: 1, children: _jsx(Typography, { variant: "subtitle1", children: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u043D\u044F \u0432..." }) }), _jsxs(Box, { ml: 1, children: [_jsxs(FormGroup, { row: true, children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { color: "primary", checked: lodash.isEqual(copy_2_days
                                        .sort()
                                        .filter((_day) => _workdays.includes(_day)), _workdays), indeterminate: copy_2_days.some((_day) => _workdays.includes(_day)) &&
                                        !lodash.isEqual(copy_2_days
                                            .sort()
                                            .filter((_day) => _workdays.includes(_day)), _workdays), onChange: onChangeWeekDays }), label: "\u0411\u0443\u0434\u043D\u0438" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { color: "primary", checked: lodash.isEqual(copy_2_days
                                        .sort()
                                        .filter((_day) => _weekends.includes(_day)), _weekends), indeterminate: copy_2_days.some((_day) => _weekends.includes(_day)) &&
                                        !lodash.isEqual(copy_2_days
                                            .sort()
                                            .filter((_day) => _weekends.includes(_day)), _weekends), onChange: onChangeWeekends }), label: "\u0412\u044B\u0445\u043E\u0434\u043D\u044B\u0435" })] }), _jsx(FormGroup, { row: true, children: days.map((_day) => (_jsx(FormControlLabel, { control: _jsx(Checkbox, { color: "primary", checked: _day.id !== current_day
                                    ? copy_2_days.includes(_day.id)
                                    : true, onChange: onChangeDays(_day.id), disabled: _day.id === current_day }), label: _day.name }, _day.id))) })] }), _jsx(Box, { display: "flex", justifyContent: "flex-end", children: _jsx(Button, { color: "primary", startIcon: _jsx(FileCopy, {}), onClick: onClickCopy, children: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }) })] }));
});
